import heroElephants from '../assets/images/hero-elephants.jpg';
import heroZebras from '../assets/images/hero-zebras.jpg';
import heroBeach from '../assets/images/hero-beach.jpg';
import heroGiraffe from '../assets/images/hero-giraffe.jpg';
import ngorongoroWildlife from '../assets/images/ngorongoro-wildlife.png';
import ngorongoroCrater from '../assets/images/ngorongoro-crater.jpg';
import ngorongoroRim from '../assets/images/ngorongoro-rim.jpg';
import ngorongoroCulture from '../assets/images/ngorongoro-culture.jpg';
import ngorongoroOverviewLion from '../assets/images/ngorongoro-overview-lion.jpg';
import ngorongoroHero1 from '../assets/images/ngorongoro-hero-1.jpg';
import ngorongoroHero2 from '../assets/images/ngorongoro-hero-2.jpg';
import ngorongoroHero3 from '../assets/images/ngorongoro-hero-3.jpg';
import ngorongoroHero4 from '../assets/images/ngorongoro-hero-4.jpg';
import ngorongoroHero5 from '../assets/images/ngorongoro-hero-5.jpg';
import ngorongoroHero6 from '../assets/images/ngorongoro-hero-6.jpg';
import serengetiWildlife from '../assets/images/serengeti-wildlife.png';
import serengetiMigration from '../assets/images/serengeti-migration.png';
import serengetiBalloon from '../assets/images/serengeti-balloon.png';
import serengetiSign from '../assets/images/serengeti-sign.jpg';
import serengetiHero1 from '../assets/images/serengeti-hero-1.jpg';
import serengetiHero2 from '../assets/images/serengeti-hero-2.jpg';
import serengetiHero3 from '../assets/images/serengeti-hero-3.jpg';
import serengetiHero4 from '../assets/images/serengeti-hero-4.jpg';
import serengetiHero5 from '../assets/images/serengeti-hero-5.jpg';
import serengetiHero6 from '../assets/images/serengeti-hero-6.jpg';
import mikumiHero from '../assets/images/mikumi-hero.png';
import mikumiHero1 from '../assets/images/mikumi-hero-1.jpg';
import mikumiHero2 from '../assets/images/mikumi-hero-2.jpg';
import mikumiHero3 from '../assets/images/mikumi-hero-3.jpg';
import mikumiHero4 from '../assets/images/mikumi-hero-4.jpg';
import mikumiHero5 from '../assets/images/mikumi-hero-5.jpg';
import mikumiHero6 from '../assets/images/mikumi-hero-6.jpg';
import mikumiHero7 from '../assets/images/mikumi-hero-7.jpg';
import mikumiHero8 from '../assets/images/mikumi-hero-8.jpg';
import mikumiWildlife from '../assets/images/mikumi-wildlife.png';
import mikumiPlains from '../assets/images/mikumi-plains.jpg';
import mikumiSavanna from '../assets/images/mikumi-savanna.jpg';
import mikumiOverview from '../assets/images/mikumi-overview.jpg';
import mikumiRoad from '../assets/images/mikumi-road.png';
import nyerereHero1 from '../assets/images/nyerere-hero-1.jpg';
import nyerereHero2 from '../assets/images/nyerere-hero-2.jpg';
import nyerereHero3 from '../assets/images/nyerere-hero-3.jpg';
import nyerereHero4 from '../assets/images/nyerere-hero-4.jpg';
import nyerereOverview from '../assets/images/nyerere-overview.jpg';
import nyerereWildlife from '../assets/images/nyerere-wildlife.jpg';
import nyerereRiver from '../assets/images/nyerere-river.jpg';
import nyerereWalking from '../assets/images/nyerere-walking.jpg';
import ruahaHero1 from '../assets/images/ruaha-hero-1.jpg';
import ruahaHero2 from '../assets/images/ruaha-hero-2.jpg';
import ruahaHero3 from '../assets/images/ruaha-hero-3.jpg';
import ruahaHero4 from '../assets/images/ruaha-hero-4.jpg';
import ruahaOverview from '../assets/images/ruaha-overview.jpg';
import ruahaWildlife from '../assets/images/ruaha-wildlife.jpg';
import ruahaRiver from '../assets/images/ruaha-river.jpg';
import ruahaBaobab from '../assets/images/ruaha-baobab.jpg';
import ruahaSavanna from '../assets/images/ruaha-savanna.jpg';
import ruahaGallery1 from '../assets/images/ruaha-gallery-1.jpg';
import ruahaGallery2 from '../assets/images/ruaha-gallery-2.jpg';
import ruahaGallery3 from '../assets/images/ruaha-gallery-3.jpg';
import ruahaGallery4 from '../assets/images/ruaha-gallery-4.jpg';
import ruahaGallery5 from '../assets/images/ruaha-gallery-5.jpg';
import ruahaGallery6 from '../assets/images/ruaha-gallery-6.jpg';
import ruahaPackage1 from '../assets/images/ruaha-package-1.jpg';
import ruahaPackage2 from '../assets/images/ruaha-package-2.jpg';
import ruahaPackage3 from '../assets/images/ruaha-package-3.jpg';
import ruahaPackage4 from '../assets/images/ruaha-package-4.jpg';
import udzungwaHero1 from '../assets/images/udzungwa-hero-1.jpg';
import udzungwaHero2 from '../assets/images/udzungwa-hero-2.jpg';
import udzungwaHero3 from '../assets/images/udzungwa-hero-3.jpg';
import udzungwaHero4 from '../assets/images/udzungwa-hero-4.jpg';
import udzungwaOverview from '../assets/images/udzungwa-overview.jpg';
import udzungwaWildlife from '../assets/images/udzungwa-wildlife.jpg';
import udzungwaWaterfall from '../assets/images/udzungwa-waterfall.jpg';
import udzungwaForest from '../assets/images/udzungwa-forest.jpg';
import udzungwaTrail from '../assets/images/udzungwa-trail.jpg';
import tarangireHero from '../assets/images/tarangire-hero.jpg';
import tarangireWildlife from '../assets/images/tarangire-wildlife.png';
import tarangireRiver from '../assets/images/tarangire-river.jpg';
import tarangireBaobabs from '../assets/images/tarangire-baobabs.jpg';
import tarangireOverview from '../assets/images/tarangire-overview.jpg';
import tarangireSavanna from '../assets/images/tarangire-savanna.jpg';
import tarangireHero1 from '../assets/images/tarangire-hero-1.jpg';
import tarangireHero2 from '../assets/images/tarangire-hero-2.jpg';
import tarangireHero3 from '../assets/images/tarangire-hero-3.jpg';
import tarangireHero4 from '../assets/images/tarangire-hero-4.jpg';
import tarangireHero5 from '../assets/images/tarangire-hero-5.jpg';
import tarangireHero6 from '../assets/images/tarangire-hero-6.jpg';
import manyaraHeroSlide1 from '../assets/images/manyara-hero-1.jpg';
import manyaraHeroSlide2 from '../assets/images/manyara-hero-2.jpg';
import manyaraHeroSlide3 from '../assets/images/manyara-hero-3.jpg';
import manyaraHeroSlide4 from '../assets/images/manyara-hero-4.jpg';
import manyaraHeroSlide5 from '../assets/images/manyara-hero-5.jpg';
import manyaraOverview from '../assets/images/manyara-overview.jpg';
import manyaraWildlife from '../assets/images/manyara-wildlife.jpg';
import manyaraLake from '../assets/images/manyara-lake.jpg';
import manyaraForest from '../assets/images/manyara-forest.jpg';
import manyaraEscarpment from '../assets/images/manyara-escarpment.jpg';
import manyaraRiftValley from '../assets/images/manyara-rift-valley.jpg';
import arushaParkHero1 from '../assets/images/arusha-park-hero-1.jpg';
import arushaParkHero2 from '../assets/images/arusha-park-hero-2.jpg';
import arushaParkHero3 from '../assets/images/arusha-park-hero-3.jpg';
import arushaParkHero4 from '../assets/images/arusha-park-hero-4.jpg';
import arushaParkOverview from '../assets/images/arusha-park-overview.jpg';
import arushaParkWildlife from '../assets/images/arusha-park-wildlife.jpg';
import arushaParkLake from '../assets/images/arusha-park-lake.jpg';
import arushaParkForest from '../assets/images/arusha-park-forest.jpg';
import arushaParkCrater from '../assets/images/arusha-park-crater.jpg';
import zanzibarHero1 from '../assets/images/zanzibar-hero-1.jpg';
import zanzibarHero2 from '../assets/images/zanzibar-hero-2.jpg';
import zanzibarHero3 from '../assets/images/zanzibar-hero-3.jpg';
import zanzibarHero4 from '../assets/images/zanzibar-hero-4.jpg';
import zanzibarHero5 from '../assets/images/zanzibar-hero-5.jpg';
import zanzibarHero6 from '../assets/images/zanzibar-hero-6.jpg';
import zanzibarBeach from '../assets/images/zanzibar-beach.jpg';
import zanzibarCoast from '../assets/images/zanzibar-coast.jpg';
import zanzibarOverview from '../assets/images/zanzibar-overview.jpg';
import zanzibarDhow from '../assets/images/zanzibar-dhow.jpg';
import zanzibarStonetown from '../assets/images/zanzibar-stonetown.png';
import zanzibarSpices from '../assets/images/zanzibar-spices.png';
import zanzibarForest from '../assets/images/zanzibar-forest.jpg';
import zanzibarPackageStonetown from '../assets/images/zanzibar-package-stonetown.jpg';
import zanzibarPackageCombo from '../assets/images/zanzibar-package-combo.jpg';
import zanzibarGallerySpices from '../assets/images/zanzibar-gallery-spices.jpg';
import zanzibarGalleryStonetown from '../assets/images/zanzibar-gallery-stonetown.jpg';
import zanzibarGalleryDhow from '../assets/images/zanzibar-gallery-dhow.jpg';
import zanzibarExperienceStonetown from '../assets/images/zanzibar-experience-stonetown.jpg';
import zanzibarExperienceSpices from '../assets/images/zanzibar-experience-spices.jpg';
import zanzibarHighlightStonetown from '../assets/images/zanzibar-highlight-stonetown.jpg';
import zanzibarHighlightSpices from '../assets/images/zanzibar-highlight-spices.jpg';
import zanzibarHighlightBeach from '../assets/images/zanzibar-highlight-beach.jpg';
import zanzibarHighlightReef from '../assets/images/zanzibar-highlight-reef.jpg';
import zanzibarHighlightForest from '../assets/images/zanzibar-highlight-forest.jpg';
import zanzibarHighlightDhow from '../assets/images/zanzibar-highlight-dhow.jpg';
import mafiaHero from '../assets/images/mafia-hero.jpg';
import mafiaBeach from '../assets/images/mafia-beach.jpg';
import mafiaReef from '../assets/images/mafia-reef.jpg';
import mafiaCoast from '../assets/images/mafia-coast.jpg';
import mafiaOverview from '../assets/images/mafia-overview.jpg';
import mafiaMarine from '../assets/images/mafia-marine.jpg';
import mafiaChole from '../assets/images/mafia-chole.png';
import kilimanjaroSummit from '../assets/images/kilimanjaro-summit.jpg';
import kilimanjaroRainforest from '../assets/images/kilimanjaro-rainforest.jpg';
import kilimanjaroMoorland from '../assets/images/kilimanjaro-moorland.jpg';
import kilimanjaroRoute from '../assets/images/kilimanjaro-route.jpg';
import kilimanjaroOverview from '../assets/images/kilimanjaro-overview.jpg';
import kilimanjaroCamps from '../assets/images/kilimanjaro-camps.jpg';
import kilimanjaroMountain from '../assets/images/kilimanjaro-mountain.jpg';
import kilimanjaroHeroSlide1 from '../assets/images/kilimanjaro-hero-1.jpg';
import kilimanjaroHeroSlide2 from '../assets/images/kilimanjaro-hero-2.jpg';
import kilimanjaroHeroSlide3 from '../assets/images/kilimanjaro-hero-3.jpg';
import kilimanjaroHeroSlide4 from '../assets/images/kilimanjaro-hero-4.jpg';
import kilimanjaroHeroSlide5 from '../assets/images/kilimanjaro-hero-5.jpg';
import meruHeroSlide1 from '../assets/images/meru-hero-1.jpg';
import meruHeroSlide2 from '../assets/images/meru-hero-2.jpg';
import meruHeroSlide3 from '../assets/images/meru-hero-3.jpg';
import meruHeroSlide4 from '../assets/images/meru-hero-4.jpg';
import meruMountain from '../assets/images/meru-hero-1.jpg';
import meruSummit from '../assets/images/meru-summit.jpg';
import meruCrater from '../assets/images/meru-crater.jpg';
import meruForest from '../assets/images/meru-forest.jpg';
import meruWildlife from '../assets/images/meru-wildlife.jpg';
import meruHuts from '../assets/images/meru-huts.jpg';
import meruOverview from '../assets/images/meru-overview.jpg';
import meruRoute from '../assets/images/meru-route.jpg';
import safarisGameDrive from '../assets/images/safaris-game-drive.jpg';
import safarisBalloon from '../assets/images/safaris-balloon.jpg';
import safarisWalking from '../assets/images/safaris-walking.jpg';
import safarisCultural from '../assets/images/safaris-cultural.jpg';
import safarisBoat from '../assets/images/safaris-boat.jpg';
import safarisSouthernCircuit from '../assets/images/safaris-southern-circuit.jpg';
import safarisNorthernCircuit from '../assets/images/safaris-northern-circuit.jpg';
import safarisNightDrive from '../assets/images/safaris-night-drive.jpg';
import homeHero01 from '../assets/images/home-hero-01.jpg';
import homeHero02 from '../assets/images/home-hero-02.jpg';
import homeHero03 from '../assets/images/home-hero-03.jpg';
import homeHero04 from '../assets/images/home-hero-04.jpg';
import homeHero05 from '../assets/images/home-hero-05.jpg';
import homeHero06 from '../assets/images/home-hero-06.jpg';
import homeHero07 from '../assets/images/home-hero-07.jpg';
import homeHero08 from '../assets/images/home-hero-08.jpg';
import homeHero09 from '../assets/images/home-hero-09.jpg';
import homeHero10 from '../assets/images/home-hero-10.jpg';
import homeHero11 from '../assets/images/home-hero-11.jpg';
import homeHero12 from '../assets/images/home-hero-12.jpg';
import homeHero13 from '../assets/images/home-hero-13.jpg';

/**
 * Home hero slideshow — bundled Pexels images.
 */
export const HERO_SLIDES = [
  {
    src: homeHero01,
    label: 'Zebras standing in water',
    position: 'center 45%',
    eyebrow: 'Wildlife Safaris',
    title: 'Your adventure starts',
    titleAccent: 'on the endless savanna',
    lead: 'Track zebras, lions, and the Great Migration across Tanzania\'s legendary plains.',
  },
  {
    src: homeHero02,
    label: 'Rhinos in the Serengeti',
    position: 'center 40%',
    eyebrow: 'Serengeti National Park',
    title: 'Witness the Big Five',
    titleAccent: 'in wild Serengeti country',
    lead: 'Rhinos, lions, elephants, and more, predator and prey drama on Africa\'s greatest stage.',
  },
  {
    src: homeHero03,
    label: 'Lioness in Tanzania wilderness',
    position: 'center 38%',
    eyebrow: 'Northern Circuit',
    title: 'Predator country',
    titleAccent: 'where lions rule the plains',
    lead: 'From Serengeti prides to Ngorongoro Crater, Tanzania hosts Africa\'s finest big cat viewing.',
  },
  {
    src: homeHero04,
    label: 'Herd on the savanna',
    position: 'center 42%',
    eyebrow: 'Great Migration',
    title: 'Follow the herds',
    titleAccent: 'across golden grasslands',
    lead: 'Over 1.5 million wildebeest circle the ecosystem, river crossings and calving season year-round.',
  },
  {
    src: homeHero05,
    label: 'Tanzania landscape under blue sky',
    position: 'center 35%',
    eyebrow: 'Discover Tanzania',
    title: 'Landscapes that',
    titleAccent: 'take your breath away',
    lead: 'From Rift Valley escarpments to open savanna horizons, every drive reveals a new vista.',
  },
  {
    src: homeHero06,
    label: 'Tropical sea at sunset',
    position: 'center 40%',
    eyebrow: 'Coast & Islands',
    title: 'Your journey continues',
    titleAccent: 'on sun-warmed shores',
    lead: 'Unwind on Zanzibar and Mafia after your safari, turquoise water, dhow sails, and golden sunsets.',
  },
  {
    src: homeHero07,
    label: 'The Rock restaurant, Zanzibar',
    position: 'center 45%',
    eyebrow: 'Zanzibar',
    title: 'Culture, spice',
    titleAccent: 'and Indian Ocean magic',
    lead: 'Stone Town heritage, spice farms, and iconic beach dining, the perfect post-safari escape.',
  },
  {
    src: homeHero08,
    label: 'Mount Kilimanjaro, Tanzania',
    position: 'center 35%',
    eyebrow: 'Mount Kilimanjaro',
    title: 'Stand on the roof',
    titleAccent: 'of Africa',
    lead: 'Climb Kilimanjaro via Marangu, Machame, or Lemosho, guided treks tailored to your pace.',
  },
  {
    src: homeHero09,
    label: 'View of Kilimanjaro',
    position: 'center 40%',
    eyebrow: 'Trekking Adventures',
    title: 'Africa\'s highest peak',
    titleAccent: 'awaits your footsteps',
    lead: 'Rainforest, moorland, and alpine desert, a multi-day journey to 5,895 metres.',
  },
  {
    src: homeHero10,
    label: 'Snow-capped mountain in clouds',
    position: 'center 30%',
    eyebrow: 'Mountains & Trails',
    title: 'Peaks above the clouds',
    titleAccent: 'and forests below',
    lead: 'Kilimanjaro, Meru, and Udzungwa rainforest trekking in Tanzania from summit to canopy.',
  },
  {
    src: homeHero11,
    label: 'Sunrise over snowy mountain',
    position: 'center 35%',
    eyebrow: 'Summit Dreams',
    title: 'Greet the dawn',
    titleAccent: 'from the crater rim',
    lead: 'Licensed guides, porters, and safety-first planning on every mountain route we offer.',
  },
  {
    src: homeHero12,
    label: 'Boats on the shore at sunset',
    position: 'center 45%',
    eyebrow: 'Island Life',
    title: 'Slow down by the sea',
    titleAccent: 'after the wild',
    lead: 'Dhow trips, reef snorkelling, and quiet beaches, Mafia and Zanzibar at their most peaceful.',
  },
  {
    src: homeHero13,
    label: 'Aerial view of a tropical beach',
    position: 'center 40%',
    eyebrow: 'Mori Tours',
    title: 'Safari, trek, beach',
    titleAccent: 'all in one journey',
    lead: 'Mori Tours crafts tailor-made Tanzania itineraries from Arusha to the Indian Ocean.',
  },
];

export const HERO_IMAGE = homeHero01;

export const NGORONGORO_PAGE_IMAGES = {
  hero: ngorongoroHero5,
  overview: ngorongoroOverviewLion,
  wildlife: ngorongoroWildlife,
  crater: ngorongoroCrater,
  rim: ngorongoroRim,
  culture: ngorongoroCulture,
};

export const NGORONGORO_HERO_SLIDES = [
  {
    src: ngorongoroHero1,
    label: 'African lions resting in the savannah',
    position: 'center 40%',
  },
  {
    src: ngorongoroHero2,
    label: 'Bird perched on a branch',
    position: 'center 35%',
  },
  {
    src: ngorongoroHero3,
    label: 'Sable antelopes in the savanna',
    position: 'center 42%',
  },
  {
    src: ngorongoroHero4,
    label: 'African buffalo close-up',
    position: 'center 38%',
  },
  {
    src: ngorongoroHero5,
    label: 'Panoramic view of Ngorongoro Crater',
    position: 'center 45%',
  },
  {
    src: ngorongoroHero6,
    label: 'Zebras grazing on green grass',
    position: 'center 40%',
  },
];

export const SERENGETI_PAGE_IMAGES = {
  hero: serengetiHero1,
  overview: serengetiSign,
  wildlife: serengetiWildlife,
  migration: serengetiMigration,
  balloon: serengetiBalloon,
  savanna: heroZebras,
};

export const SERENGETI_HERO_SLIDES = [
  {
    src: serengetiHero1,
    label: 'Zebras on the Serengeti plains',
    position: 'center 40%',
  },
  {
    src: serengetiHero2,
    label: 'Lion resting in the grass',
    position: 'center 42%',
  },
  {
    src: serengetiHero3,
    label: 'Cheetah on the savanna',
    position: 'center 38%',
  },
  {
    src: serengetiHero4,
    label: 'Hot air balloon over the Serengeti',
    position: 'center 35%',
  },
  {
    src: serengetiHero5,
    label: 'Giraffes walking on the plains',
    position: 'center 40%',
  },
  {
    src: serengetiHero6,
    label: 'Wildlife at a waterhole',
    position: 'center 45%',
  },
];

export const MIKUMI_PAGE_IMAGES = {
  overview: mikumiOverview,
  wildlife: mikumiWildlife,
  plains: mikumiPlains,
  savanna: mikumiSavanna,
  road: mikumiRoad,
  classic: mikumiHero,
  gazelles: mikumiHero5,
  warthog: mikumiHero6,
  baboon: mikumiHero7,
  zebra: mikumiHero8,
};

/** Hero slideshow backgrounds for Mikumi (Pexels wildlife set) */
export const MIKUMI_HERO_SLIDES = [
  {
    src: mikumiHero1,
    label: 'African leopard stalking in natural habitat',
    position: 'center 40%',
  },
  {
    src: mikumiHero2,
    label: 'Buffalo standing on a grass field',
    position: 'center 42%',
  },
  {
    src: mikumiHero3,
    label: 'Giraffe in Tanzania wilderness',
    position: 'center 35%',
  },
  {
    src: mikumiHero4,
    label: 'Warthogs grazing in Mikumi National Park',
    position: 'center 45%',
  },
  {
    src: mikumiHero5,
    label: 'Gazelles walking on grass field',
    position: 'center 40%',
  },
  {
    src: mikumiHero6,
    label: 'Warthog lying down on grass',
    position: 'center 48%',
  },
  {
    src: mikumiHero7,
    label: 'Baboon sitting on ground',
    position: 'center 38%',
  },
  {
    src: mikumiHero8,
    label: 'Dramatic zebra confrontation on the savannah',
    position: 'center 42%',
  },
];

export const NYERERE_PAGE_IMAGES = {
  hero: nyerereHero1,
  overview: nyerereOverview,
  wildlife: nyerereWildlife,
  river: nyerereRiver,
  walking: nyerereWalking,
  savanna: nyerereHero3,
};

export const NYERERE_HERO_SLIDES = [
  {
    src: nyerereHero1,
    label: 'Hippos on the Rufiji River',
    position: 'center 45%',
  },
  {
    src: nyerereHero2,
    label: 'Wildlife on the savanna',
    position: 'center 40%',
  },
  {
    src: nyerereHero3,
    label: 'Southern wilderness road',
    position: 'center 38%',
  },
  {
    src: nyerereHero4,
    label: 'Wildebeest on the plains',
    position: 'center 35%',
  },
];

export const RUAHA_PAGE_IMAGES = {
  hero: ruahaHero1,
  overview: ruahaOverview,
  wildlife: ruahaWildlife,
  river: ruahaRiver,
  baobab: ruahaBaobab,
  savanna: ruahaSavanna,
  galleryLioness: ruahaGallery1,
  galleryElephants: ruahaGallery2,
  galleryGiraffe: ruahaGallery3,
  galleryLeopard: ruahaGallery4,
  galleryHippos: ruahaGallery5,
  galleryWildDog: ruahaGallery6,
  packageLodge: ruahaPackage1,
  packageCrocodile: ruahaPackage2,
  packageJeeps: ruahaPackage3,
  packageHiking: ruahaPackage4,
};

export const RUAHA_HERO_SLIDES = [
  {
    src: ruahaHero1,
    label: 'Elephants on the Ruaha savanna',
    position: 'center 42%',
  },
  {
    src: ruahaHero2,
    label: 'Southern Tanzania elephant herds',
    position: 'center 40%',
  },
  {
    src: ruahaHero3,
    label: 'Great Ruaha River waterhole',
    position: 'center 45%',
  },
  {
    src: ruahaHero4,
    label: 'Lions of Ruaha',
    position: 'center 38%',
  },
];

export const UDZUNGWA_PAGE_IMAGES = {
  hero: udzungwaHero1,
  overview: udzungwaOverview,
  wildlife: udzungwaWildlife,
  waterfall: udzungwaWaterfall,
  forest: udzungwaForest,
  trail: udzungwaTrail,
};

export const UDZUNGWA_HERO_SLIDES = [
  {
    src: udzungwaHero1,
    label: 'Eastern Arc rainforest canopy',
    position: 'center 40%',
  },
  {
    src: udzungwaHero2,
    label: 'Waterfall in the forest',
    position: 'center 45%',
  },
  {
    src: udzungwaHero3,
    label: 'Rainforest hiking trail',
    position: 'center 42%',
  },
  {
    src: udzungwaHero4,
    label: 'Lush mountain forest',
    position: 'center 38%',
  },
];

export const TARANGIRE_PAGE_IMAGES = {
  hero: tarangireHero1,
  overview: tarangireOverview,
  wildlife: tarangireWildlife,
  river: tarangireRiver,
  baobabs: tarangireBaobabs,
  savanna: tarangireSavanna,
};

export const TARANGIRE_HERO_SLIDES = [
  {
    src: tarangireHero1,
    label: 'Elephant herd on the grassland',
    position: 'center 42%',
  },
  {
    src: tarangireHero2,
    label: 'Trees on the savanna',
    position: 'center 40%',
  },
  {
    src: tarangireHero3,
    label: 'Hyena in the wild',
    position: 'center 38%',
  },
  {
    src: tarangireHero4,
    label: 'Giraffes walking on the grass',
    position: 'center 40%',
  },
  {
    src: tarangireHero5,
    label: 'Lion on the savanna',
    position: 'center 42%',
  },
  {
    src: tarangireHero6,
    label: 'Baobab tree in safari landscape',
    position: 'center 45%',
  },
];

export const MANYARA_PAGE_IMAGES = {
  hero: manyaraHeroSlide1,
  overview: manyaraOverview,
  wildlife: manyaraWildlife,
  lake: manyaraLake,
  forest: manyaraForest,
  escarpment: manyaraEscarpment,
  riftValley: manyaraRiftValley,
};

export const MANYARA_HERO_SLIDES = [
  {
    src: manyaraHeroSlide1,
    label: 'Flamingos flying over Lake Manyara',
    position: 'center 40%',
  },
  {
    src: manyaraHeroSlide2,
    label: 'Wildebeest herd at the river',
    position: 'center 45%',
  },
  {
    src: manyaraHeroSlide3,
    label: 'Hippos wading in the river',
    position: 'center 50%',
  },
  {
    src: manyaraHeroSlide4,
    label: 'Pink flamingos on the water',
    position: 'center 35%',
  },
  {
    src: manyaraHeroSlide5,
    label: 'Scenic Rift Valley landscape',
    position: 'center 40%',
  },
];

export const ARUSHA_PARK_PAGE_IMAGES = {
  hero: arushaParkHero1,
  overview: arushaParkOverview,
  wildlife: arushaParkWildlife,
  lake: arushaParkLake,
  forest: arushaParkForest,
  crater: arushaParkCrater,
};

export const ARUSHA_PARK_HERO_SLIDES = [
  {
    src: arushaParkHero1,
    label: 'Mount Meru under clear blue sky',
    position: 'center 40%',
  },
  {
    src: arushaParkHero2,
    label: 'Green forest on the Meru slopes',
    position: 'center 35%',
  },
  {
    src: arushaParkHero3,
    label: 'Volcanic landscapes of Arusha National Park',
    position: 'center 45%',
  },
  {
    src: arushaParkHero4,
    label: 'Giraffe on the park grasslands',
    position: 'center 38%',
  },
];

export const ZANZIBAR_PAGE_IMAGES = {
  hero: zanzibarHero1,
  overview: zanzibarOverview,
  beach: zanzibarBeach,
  coast: zanzibarCoast,
  stonetown: zanzibarStonetown,
  spices: zanzibarSpices,
  forest: zanzibarForest,
  dhow: zanzibarDhow,
  packageStonetown: zanzibarPackageStonetown,
  packageCombo: zanzibarPackageCombo,
  gallerySpices: zanzibarGallerySpices,
  galleryStonetown: zanzibarGalleryStonetown,
  galleryDhow: zanzibarGalleryDhow,
  experienceStonetown: zanzibarExperienceStonetown,
  experienceSpices: zanzibarExperienceSpices,
  highlightStonetown: zanzibarHighlightStonetown,
  highlightSpices: zanzibarHighlightSpices,
  highlightBeach: zanzibarHighlightBeach,
  highlightReef: zanzibarHighlightReef,
  highlightForest: zanzibarHighlightForest,
  highlightDhow: zanzibarHighlightDhow,
};

/** Hero slideshow backgrounds for Zanzibar */
export const ZANZIBAR_HERO_SLIDES = [
  {
    src: zanzibarHero1,
    label: 'People at a beach in Zanzibar',
    position: 'center 40%',
  },
  {
    src: zanzibarHero2,
    label: 'Colorful signpost on Paje Beach',
    position: 'center 42%',
  },
  {
    src: zanzibarHero3,
    label: 'Melia Zanzibar luxury beach',
    position: 'center 45%',
  },
  {
    src: zanzibarHero4,
    label: 'Paradise beach under blue sky',
    position: 'center 38%',
  },
  {
    src: zanzibarHero5,
    label: 'Luxury resort poolside at Jambiani',
    position: 'center 40%',
  },
  {
    src: zanzibarHero6,
    label: 'Beach hut with thatched roof at sunset',
    position: 'center 45%',
  },
];

export const MAFIA_PAGE_IMAGES = {
  hero: mafiaHero,
  overview: mafiaOverview,
  beach: mafiaBeach,
  reef: mafiaReef,
  coast: mafiaCoast,
  marine: mafiaMarine,
  chole: mafiaChole,
};

export const KILIMANJARO_HERO_SLIDES = [
  {
    src: kilimanjaroHeroSlide1,
    label: 'Mount Kilimanjaro under clear sky',
    position: 'center 40%',
  },
  {
    src: kilimanjaroHeroSlide2,
    label: 'Trekkers on Mount Kilimanjaro',
    position: 'center 35%',
  },
  {
    src: kilimanjaroHeroSlide3,
    label: 'Elephant family on the savannah near Kilimanjaro',
    position: 'center 45%',
  },
  {
    src: kilimanjaroHeroSlide4,
    label: 'Green foothills below Kilimanjaro',
    position: 'center 50%',
  },
  {
    src: kilimanjaroHeroSlide5,
    label: 'Group hiking in mountain snow at sunrise',
    position: 'center 30%',
  },
];

export const KILIMANJARO_PAGE_IMAGES = {
  hero: kilimanjaroHeroSlide1,
  mountain: kilimanjaroMountain,
  overview: kilimanjaroOverview,
  summit: kilimanjaroSummit,
  rainforest: kilimanjaroRainforest,
  moorland: kilimanjaroMoorland,
  route: kilimanjaroRoute,
  camps: kilimanjaroCamps,
};

export const MERU_HERO_SLIDES = [
  {
    src: meruHeroSlide1,
    label: 'Mount Meru under clear blue sky',
    position: 'center 40%',
  },
  {
    src: meruHeroSlide2,
    label: 'Green trees near Mount Meru',
    position: 'center 35%',
  },
  {
    src: meruHeroSlide3,
    label: 'Arusha National Park crossing',
    position: 'center 45%',
  },
  {
    src: meruHeroSlide4,
    label: 'Clouds over volcanic crater',
    position: 'center 30%',
  },
];

export const MERU_PAGE_IMAGES = {
  hero: meruHeroSlide1,
  mountain: meruMountain,
  overview: meruOverview,
  summit: meruSummit,
  crater: meruCrater,
  forest: meruForest,
  wildlife: meruWildlife,
  huts: meruHuts,
  route: meruRoute,
};

export const SAFARI_HERO_SLIDES = [
  {
    src: heroZebras,
    label: 'Zebras on the savanna',
    position: 'center 40%',
    eyebrow: 'Savanna plains',
    title: 'Track the herds',
    titleAccent: 'across golden grasslands',
    lead: 'Follow zebra and wildebeest across open plains the classic East African safari scene, alive on every game drive.',
  },
  {
    src: heroElephants,
    label: 'Elephant herd on safari',
    position: 'center 45%',
    eyebrow: 'Elephant country',
    title: 'Walk among giants',
    titleAccent: 'on the African savanna',
    lead: 'Tarangire and Ruaha host some of Africa\'s largest elephant populations family herds moving through baobab-studded landscapes.',
  },
  {
    src: serengetiMigration,
    label: 'Great Migration on the plains',
    position: 'center 35%',
    eyebrow: 'Great Migration',
    title: 'Witness nature\'s',
    titleAccent: 'greatest spectacle',
    lead: 'Over 1.5 million wildebeest circle the Serengeti ecosystem river crossings, calving season, and predator drama year-round.',
  },
  {
    src: heroGiraffe,
    label: 'Giraffe in Tanzania',
    position: 'center 38%',
    eyebrow: 'Northern Circuit',
    title: 'Discover Tanzania',
    titleAccent: 'where wildlife meets the sky',
    lead: 'From Ngorongoro Crater to the Serengeti iconic parks, expert guides, and landscapes that stay with you forever.',
  },
];

export const SAFARI_PAGE_IMAGES = {
  hero: heroZebras,
  overview: serengetiWildlife,
  gameDrive: safarisGameDrive,
  balloon: safarisBalloon,
  walking: safarisWalking,
  cultural: safarisCultural,
  boat: safarisBoat,
  nightDrive: safarisNightDrive,
  northern: safarisNorthernCircuit,
  southern: safarisSouthernCircuit,
  western: tarangireHero,
  shortTrip: tarangireWildlife,
  classicTrip: serengetiMigration,
  extendedTrip: heroElephants,
};

export const DESTINATION_IMAGES = {
  serengeti: serengetiHero1,
  ngorongoro: ngorongoroOverviewLion,
  zanzibar: zanzibarBeach,
  mafia: mafiaBeach,
  kilimanjaro: kilimanjaroHeroSlide1,
  meru: meruHeroSlide1,
  mikumi: mikumiWildlife,
  nyerere: nyerereWildlife,
  ruaha: ruahaWildlife,
  udzungwa: udzungwaWildlife,
  tarangire: tarangireOverview,
  manyara: manyaraLake,
  'arusha-park': arushaParkHero1,
};

export const IMAGE_FALLBACK = heroElephants;
